import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const Support = () => {
  const { t } = useTranslation();
  return (
    <div className="container text-relevant text-justify">
      <h1>{t("donations")}</h1>
      <p>{t("support-p1")}</p>
      <p>{t("support-p2")}</p>
      <div className="row">
        <div className="col-md">
          <ul>
            <li>
              <span className="bold">
                <a
                  href={`${process.env.REACT_APP_API_URL}/pdf/financial/financial-statement-notes.pdf`}
                  target="_blank"
                  rel="noopener"
                >
                  {t("support-p3b")}
                </a>
              </span>
            </li>
            <li>
              <span className="bold">
                <a
                  href={`${process.env.REACT_APP_API_URL}/pdf/financial/financial-statement.pdf`}
                  target="_blank"
                  rel="noopener"
                >
                  {t("support-p3a")}
                </a>
              </span>
            </li>
            <li>
              <span className="bold">{t("financial-separation")}: </span>
              {t("support-p4")}
            </li>
            <li>
              <div>
                <span className="bold">{t("faith")}: </span>
                {t("support-p5")}
                <ul>
                  <li>{t("support-p6")}</li>
                  <li>{t("support-p7")}</li>
                  <li>{t("support-p8")}</li>
                </ul>
              </div>
            </li>
            <li>
              <div>
                <span className="bold">{t("accountability")}: </span>
                <ul>
                  <li>{t("support-p9")}</li>
                </ul>
              </div>
            </li>
            <li>
              <span className="bold">{t("cash-basis")}: </span>
              {t("support-p10")}
            </li>
          </ul>
        </div>
        <div className="col-md">
          <img
            className="img-thumbnail"
            src={"https://www.chapellibrary.org/images/intnl-orders.png"}
            alt="International Orders"
            style={{ "--aspect-ratio": "630/452" }}
          />
          <img
            className="img-thumbnail"
            src={"https://www.chapellibrary.org/images/intnl-orders-map.jpg"}
            alt="Chapel Library Orders Map"
            style={{ "--aspect-ratio": "991/595" }}
          />
        </div>
      </div>

      <ul>
        <li>
          <span className="bold">{t("accounting-practices")}: </span>
          {t("support-p11")}
        </li>
        <li>
          <div>
            <span className="bold">{t("operational-guidelines")}:</span>
            <ol>
              <li>{t("support-p12")}</li>
              <li>{t("support-p13")}</li>
              <li>{t("support-p14")}</li>
              <li>{t("support-p15")}</li>
            </ol>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Support;
